module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_2_1.75c8778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_2_1.png
// module id = X45+
// module chunks = 34